/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Single IMU reading — median sample from the capture window.
 * @export
 * @interface ImuSample
 */
export interface ImuSample {
    [key: string]: any | any;
    /**
     * 
     */
    timestamp?: number | null;
    /**
     * 
     */
    accRawX?: number | null;
    /**
     * 
     */
    accRawY?: number | null;
    /**
     * 
     */
    accRawZ?: number | null;
    /**
     * 
     */
    accGX?: number | null;
    /**
     * 
     */
    accGY?: number | null;
    /**
     * 
     */
    accGZ?: number | null;
    /**
     * 
     */
    gyrRawX?: number | null;
    /**
     * 
     */
    gyrRawY?: number | null;
    /**
     * 
     */
    gyrRawZ?: number | null;
    /**
     * 
     */
    gyrDpsX?: number | null;
    /**
     * 
     */
    gyrDpsY?: number | null;
    /**
     * 
     */
    gyrDpsZ?: number | null;
    /**
     * 
     */
    rollDegrees?: number | null;
    /**
     * 
     */
    pitchDegrees?: number | null;
}

/**
 * Check if a given object implements the ImuSample interface.
 */
export function instanceOfImuSample(value: object): value is ImuSample {
    return true;
}

export function ImuSampleFromJSON(json: any): ImuSample {
    return ImuSampleFromJSONTyped(json, false);
}

export function ImuSampleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImuSample {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'timestamp': json['timestamp'] === undefined ? undefined : json['timestamp'] === null ? null : json['timestamp'],
        'accRawX': json['acc_raw_x'] === undefined ? undefined : json['acc_raw_x'] === null ? null : json['acc_raw_x'],
        'accRawY': json['acc_raw_y'] === undefined ? undefined : json['acc_raw_y'] === null ? null : json['acc_raw_y'],
        'accRawZ': json['acc_raw_z'] === undefined ? undefined : json['acc_raw_z'] === null ? null : json['acc_raw_z'],
        'accGX': json['acc_g_x'] === undefined ? undefined : json['acc_g_x'] === null ? null : json['acc_g_x'],
        'accGY': json['acc_g_y'] === undefined ? undefined : json['acc_g_y'] === null ? null : json['acc_g_y'],
        'accGZ': json['acc_g_z'] === undefined ? undefined : json['acc_g_z'] === null ? null : json['acc_g_z'],
        'gyrRawX': json['gyr_raw_x'] === undefined ? undefined : json['gyr_raw_x'] === null ? null : json['gyr_raw_x'],
        'gyrRawY': json['gyr_raw_y'] === undefined ? undefined : json['gyr_raw_y'] === null ? null : json['gyr_raw_y'],
        'gyrRawZ': json['gyr_raw_z'] === undefined ? undefined : json['gyr_raw_z'] === null ? null : json['gyr_raw_z'],
        'gyrDpsX': json['gyr_dps_x'] === undefined ? undefined : json['gyr_dps_x'] === null ? null : json['gyr_dps_x'],
        'gyrDpsY': json['gyr_dps_y'] === undefined ? undefined : json['gyr_dps_y'] === null ? null : json['gyr_dps_y'],
        'gyrDpsZ': json['gyr_dps_z'] === undefined ? undefined : json['gyr_dps_z'] === null ? null : json['gyr_dps_z'],
        'rollDegrees': json['roll_degrees'] === undefined ? undefined : json['roll_degrees'] === null ? null : json['roll_degrees'],
        'pitchDegrees': json['pitch_degrees'] === undefined ? undefined : json['pitch_degrees'] === null ? null : json['pitch_degrees'],
    };
}

export function ImuSampleToJSON(json: any): ImuSample {
    return ImuSampleToJSONTyped(json, false);
}

export function ImuSampleToJSONTyped(value?: ImuSample | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'timestamp': value['timestamp'],
        'acc_raw_x': value['accRawX'],
        'acc_raw_y': value['accRawY'],
        'acc_raw_z': value['accRawZ'],
        'acc_g_x': value['accGX'],
        'acc_g_y': value['accGY'],
        'acc_g_z': value['accGZ'],
        'gyr_raw_x': value['gyrRawX'],
        'gyr_raw_y': value['gyrRawY'],
        'gyr_raw_z': value['gyrRawZ'],
        'gyr_dps_x': value['gyrDpsX'],
        'gyr_dps_y': value['gyrDpsY'],
        'gyr_dps_z': value['gyrDpsZ'],
        'roll_degrees': value['rollDegrees'],
        'pitch_degrees': value['pitchDegrees'],
    };
}

